export enum QuestionType {
    Check = 'checkbox',
    Comments = 'comments',
    Date = 'date',
    Datetime = 'datetime-local',
    Email = 'email',
    File = 'file',
    SingleFile = 'single_file',
    HiddenField = 'hidden_field',
    Label = 'label',
    Month = 'month',
    NestedQuestion = 'nested_question',
    Number = 'number',
    Currency = 'currency',
    Integer = 'integer',
    Fraction = 'fraction',
    Percentage = 'percentage',
    Password = 'password',
    Radio = 'radio',
    Select = 'select',
    SelectDependent = 'select_dependent',
    Telephone = 'tel',
    Text = 'text',
    Url = 'url',
    Week = 'week',
}
